export default __webpack_public_path__ + "static/media/Tuhin.4a4eb01d.png";